"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridCheckboxCell = void 0;
const react_1 = __importDefault(require("react"));
const GridCheckboxCell_1 = require("./components/GridCheckboxCell/GridCheckboxCell");
function gridCheckboxCell(config) {
    return function TextCellRenderer({ rowIndex, loading }) {
        var _a;
        const handleOnClick = (e) => {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty();
            config.onClick(rowIndex, e.shiftKey);
        };
        return (react_1.default.createElement(GridCheckboxCell_1.GridCheckboxCell, { onClick: handleOnClick, checked: config.isChecked(rowIndex), disabled: (_a = config.isDisabled) === null || _a === void 0 ? void 0 : _a.call(config, rowIndex), loading: loading }));
    };
}
exports.gridCheckboxCell = gridCheckboxCell;
//# sourceMappingURL=gridCheckboxCellRenderer.js.map